import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash.isequal';
import { Box, Flex, Image } from 'rebass/styled-components';

import { ContactsEmptyState } from './emptyState';
import { SharedListEmptyState } from './sharedListEmptyState';
import { ContactsNoResults } from '../../components/atoms/ContactsNoResult';
import SearchNoResultsIcon from '../../assets/icon-effortless-search-no-results.svg';
import IconHandEmptyIcon from '../../assets/icon-hand-empty.svg';

export const EmptyContacts = ({
  showAllContactsEmptyState,
  showListContactsEmptyState,
  isLoading,
  isFetching,
  dataCount,
  listId,
  queryParams,
  defaultFilters,
  emptyState,
  type,
}) => {
  const isNoResults = !isLoading && !dataCount && !isEqual(defaultFilters, queryParams.filters);
  const isSharedListEmpty =
    !isLoading && !isFetching && !dataCount && listId && isEqual(defaultFilters, queryParams.filters);
  const isContactsEmpty = showAllContactsEmptyState || showListContactsEmptyState;

  if (type === 'public' && !isFetching && !dataCount && !isEqual(defaultFilters, queryParams.filters)) {
    return (
      <Flex mt="40px" flexDirection="column" alignItems="center" maxWidth="520px" mx="auto" textAlign="center">
        <Image src={SearchNoResultsIcon} width="64px" maxWidth="64px" />
        <Box mt="16px" fontWeight="semibold">
          No results for this search
        </Box>
        <Box mt="8px" color="text.subtle">
          Review the filters or subscribe to get notified when new people are added.
        </Box>
      </Flex>
    );
  }
  if (type === 'public' && !isFetching && !dataCount && isEqual(defaultFilters, queryParams.filters)) {
    return (
      <Flex mt="40px" flexDirection="column" alignItems="center" maxWidth="520px" mx="auto" textAlign="center">
        <Image src={IconHandEmptyIcon} width="64px" maxWidth="64px" />
        <Box mt="16px" fontWeight="semibold">
          This list is empty
        </Box>
        <Box as="span" mt="8px" color="text.subtle">
          Subscribe to get notifications when new people are added.
        </Box>
      </Flex>
    );
  }

  return (
    <>
      {isContactsEmpty && <ContactsEmptyState isList={showListContactsEmptyState} />}
      {isSharedListEmpty && (emptyState || <SharedListEmptyState />)}
      {isNoResults && <ContactsNoResults isList={Boolean(listId)} />}
    </>
  );
};

EmptyContacts.propTypes = {
  showAllContactsEmptyState: PropTypes.bool,
  showListContactsEmptyState: PropTypes.bool,
  isLoading: PropTypes.bool,
  isFetching: PropTypes.bool,
  dataCount: PropTypes.number,
  listId: PropTypes.string,
  queryParams: PropTypes.object.isRequired,
  defaultFilters: PropTypes.object,
  emptyState: PropTypes.node,
  type: PropTypes.string,
};

EmptyContacts.defaultProps = {
  showAllContactsEmptyState: false,
  showListContactsEmptyState: false,
  isLoading: false,
  isFetching: false,
  dataCount: 0,
  listId: '',
  defaultFilters: {},
  emptyState: null,
  type: 'default',
};
